module.exports = __webpack_public_path__ + "img/Parfait.85ae3dbe.jpg";